import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Badge,
  Button,
  Image,
  Spinner,
} from "react-bootstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getLifecycle, getUserById, getUserData } from "../../services/UserServices/UserService";
import { setUserProfile, decrementUnReadUserCount } from "../../store/reducers/RoleSlice";

import { useLocation } from "react-router-dom";
const UserDetailPage = () => {
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const from = location?.state?.from
  const [lifecycle, setLifecycle] = useState([])


  const fetchUser = async () => {
    try {
      setLoading(true);
      const response = await getUserById(id);
      const fetchedUserData = response?.data?.data?.data;
      setUser(fetchedUserData);

      // Only subtract count if item was unread (isRead === false or 0)
      const isUnread = location?.state?.isRead === false || location?.state?.isRead === 0 || fetchedUserData?.isRead === false || fetchedUserData?.isRead === 0;

      if (isUnread) {
        dispatch(decrementUnReadUserCount());

        try {
          const userRes = await getUserData();
          if (userRes?.data?.data) {
            dispatch(setUserProfile(userRes.data.data));
          }
        } catch (err) {
          console.error(err);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchLifecycle = async () => {
    try {
      const response = await getLifecycle(id, 0, 10);

      setLifecycle(response?.data?.data?.data)

    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchLifecycle()
  }, [id])


  useEffect(() => {
    fetchUser();
  }, [id]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (!user) {
    return (
      <Container className="text-center mt-5">
        <h4>User Not Found</h4>
      </Container>
    );
  }
  const InfoRow = ({ label, value }) => (
    <Row className="mb-3 align-items-baseline">
      <Col sm={4} className="text-black fw-bold small text-uppercase tracking-wider">
        {label}
      </Col>
      <Col sm={8} className="text-black fw-semibold">
        {value || "-"}
      </Col>
    </Row>
  );

  const questions = {
    cleanliness: {
      title: "After dinner, when do dishes get done?",
      options: {
        immediate: "Immediately",
        beforeSleep: "Before Sleeping",
        nextMorning: "Next Morning",
        houseHelp: "House Help",
      },
    },

    diet: {
      title: "What's your diet?",
      options: {
        vegOnly: "Vegetarian / Jain – Prefer Veg-Only Kitchen",
        vegButOk: "Vegetarian But Okay With Non-Veg",
        eggetarian: "Eggetarian",
        nonVeg: "Non-Vegetarian",
      },
    },

    workFromHome: {
      title: "How often do you work from home?",
      options: {
        officeDaily: "Office Daily",
        oneTwoDays: "1–2 Days A Week",
        threeFourDays: "3–4 Days A Week",
        fullWFH: "Fully Work From Home",
      },
    },

    guests: {
      title: "How often do you have guests over?",
      options: {
        rarely: "Rarely / Never",
        onceTwice: "Once Or Twice A Month",
        weekends: "Most Weekends",
        frequent: "Frequently",
      },
    },

    smoking: {
      title: "Your flatmate smokes. What are you comfortable with?",
      options: {
        notOk: "Not Okay With Smoking",
        outsideOnly: "Only Outside Building",
        balcony: "Balcony Is Fine",
        noPref: "No Preference / I Smoke Too",
      },
    },

    drinking: {
      title: "Your flatmate pours herself a drink after work. How do you feel?",
      options: {
        notComfortable: "Not Comfortable",
        fineOccasionally: "Fine Occasionally",
        totallyFine: "Totally Fine",
        join: "I'd Probably Join",
      },
    },

    visitors: {
      title: "How do you feel about male visitors / boyfriend visiting?",
      options: {
        notComfortable: "Not Comfortable",
        shortNotice: "Fine For Short Visits With Notice",
        totallyFine: "Totally Fine",
        occasionalStay: "Fine With Occasional Stays",
      },
    },

    cleaning: {
      title: "House Help doesn’t show up. What happens?",
      options: {
        cleanMyself: "I Clean Myself",
        basicCleaning: "Basic Cleaning Only",
        manageMessy: "I Manage But It’s Messy",
        pileUp: "Things Pile Up",
      },
    },

    lateCall: {
      title: "It’s 11 PM and your flatmate is on a call in the living room",
      options: {
        preferQuiet: "Not Okay, Prefer Quiet",
        okayBriefly: "Okay Briefly",
        noIssue: "Doesn’t Bother Me",
        noProblem: "No Issue At All",
      },
    },

    expenses: {
      title: "How do you prefer splitting expenses?",
      options: {
        strict: "Strict Tracking (Splitwise Etc.)",
        monthly: "Settle Monthly",
        informal: "Informal / Trust-Based",
        separate: "Fully Separate",
      },
    },

    parents: {
      title: "Parents visiting for a few days",
      options: {
        totallyFine: "Totally Fine",
        notice: "Fine With Notice",
        uncomfortable: "Slightly Uncomfortable",
        preferNot: "Prefer Not",
      },
    },

    pets: {
      title: "Pets",
      options: {
        havePet: "I Have A Pet",
        lovePets: "Love Pets, Fine With Them",
        boundaries: "Okay With Boundaries",
        allergic: "Not Comfortable / Allergic",
      },
    },

    sleep: {
      title: "What time do you usually sleep?",
      options: {
        before10: "Before 10 PM",
        "10to12": "10 PM – 12 AM",
        "12to2": "12 AM – 2 AM",
        after2: "After 2 AM",
      },
    },
  };




  return (
    <Container className="my-4">
      <div className="d-flex justify-content-between">
        <Button
          variant="light"
          size="sm"
          className="mb-3 shadow-sm"
          onClick={() => navigate(-1)}
        >
          ← Back
        </Button>
        {user?.reportCount > 0 ? <Badge bg="danger" className=" px-3 py-2 fs-6 rounded-pill align-middle mb-3">THIS USER HAS BEEN REPORTED {user?.reportCount} TIMES</Badge> : ""}
      </div>

      <Card className="shadow-sm border-0 rounded-4 mb-4">
        <Card.Body className="p-4">
          <h5 style={{ color: "#E5484D" }} className="fw-bold mb-4 text-uppercase tracking-wide fs-6">
            Key Performance Indicators
          </h5>
          <div
            className="d-grid gap-3"
            style={{
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))"
            }}
          >
            {[
              {
                label: "Listing Ads",
                value: user.listingAdCount,
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                ),
              },
              {
                label: "Total Express Interest",
                value: user.totalExpressInterest,
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                ),
              },
              {
                label: "Flat Express Interest",
                value: user.totalFlatExpressInterest,
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                    <path d="M3 21h18M3 7v1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7m0 1a3 3 0 0 0 6 0V7M4 21V10m16 11V10M9 21v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4"></path>
                  </svg>
                ),
              },
              {
                label: "Flatmate Express Interest",
                value: user.totalFlatmateExpressInterest,
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                ),
              },
              {
                label: "Total Safety Checks",
                value: user.totalSafetyChecks,
                icon: (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  </svg>
                ),
              },
            ].map((kpi, idx) => (
              <div
                key={idx}
                className="d-flex align-items-center p-3 rounded-3 border"
                style={{
                  backgroundColor: "#FFF5F5",
                  borderColor: "#FFE3E3",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  cursor: "default"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(229, 72, 77, 0.08)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle me-3"
                  style={{
                    width: "48px",
                    height: "48px",
                    backgroundColor: "#FFE3E3",
                    flexShrink: 0
                  }}
                >
                  {kpi.icon}
                </div>
                <div>
                  <span className="d-block text-secondary small fw-semibold text-uppercase tracking-wider" style={{ fontSize: "0.75rem" }}>
                    {kpi.label}
                  </span>
                  <span className="fs-4 fw-bold text-black">
                    {kpi.value !== undefined && kpi.value !== null ? kpi.value : 0}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
      <Card className="shadow-sm border-0 rounded-4 overflow-hidden mb-4">
        <Card.Body className="p-4 p-md-5">
          <Row className="g-4">
            {/* Avatar & Verification Badges */}
            <Col lg={3} className="text-center border-end-lg border-light pe-lg-4">
              <div className="position-relative d-inline-block mb-3">
                <Image
                  src={user.image || "https://www.pngfind.com/pngs/m/610-6104451_image-placeholder-png-user-profile-placeholder-image-png.png"}
                  roundedCircle
                  width={140}
                  height={140}
                  className="border border-4 border-white shadow object-fit-cover"
                />
              </div>
              <h4 className="fw-bold text-black mb-1">{user.name}</h4>
              <p className="text-muted small mb-3">{user?.email}</p>
              <Badge
                bg={user.adminApprove === "Verified" ? "success-subtle" : "warning-subtle"}
                className={`px-3 py-2 rounded-pill fs-7 fw-bold ${user.adminApprove === "Verified" ? "text-success" : "text-warning"
                  }`}
              >
                {user.adminApprove || "Pending"}
              </Badge>
            </Col>

            {/* Profile Info Fields */}
            <Col lg={9} className="ps-lg-4">
              <h5 style={{ color: "#E5484D" }} className="fw-bold mb-3 text-uppercase tracking-wide fs-6">
                About User
              </h5>
              <p className="text-secondary bg-white p-3 rounded-3 mb-4 lh-base border-start border-3 border-danger-subtle">
                {user.basicInfo?.bio || "No bio description provided."}
              </p>

              <Row>
                <Col md={6}>
                  <InfoRow label="Language" value={user.language} />
                  <InfoRow label="Address" value={user.address} />
                  <InfoRow label="Phone" value={`${user.countryCode} ${user.phoneNumber}` || "Not Added"} />
                  <InfoRow label="Looking for " value={user.lookingAdType} />
                </Col>
                <Col md={6}>
                  <InfoRow
                    label="Created  At"
                    value={
                      user.createdAt
                        ? new Date(user.createdAt).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        : "-"
                    }
                  />
                  {/* <InfoRow label="Rating" value={user.rating ? `⭐ ${user.rating}` : "No ratings"} />
                  <InfoRow label="Bookings" value={user.bookingCount} /> */}

                </Col>
              </Row>

              {user.selfie && (
                <>
                  <hr className="my-4 opacity-25" />
                  <h6 className="text-black fw-bold mb-3 text-uppercase tracking-wide fs-7">
                    Live Selfie Verification
                  </h6>
                  <div className="d-flex align-items-center gap-3 bg-white p-3 rounded-4" style={{ width: "fit-content" }}>
                    <Image
                      src={user.selfie}
                      rounded
                      width={90}
                      height={90}
                      className="border shadow-sm object-fit-cover rounded-3"
                    />
                    <div>
                      <span className="d-block text-dark fw-bold small">Live Captures Match</span>
                      <small className="text-muted">Used to authenticate the profile identity status.</small>
                    </div>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>




      {/* VERIFICATION */}
      <Card className="shadow-sm border-0 rounded-4 mb-4">
        <Card.Body>
          <h5 style={{ color: "#E5484D" }} className="fw-bold mb-4">Verification Status</h5>

          <Row>


            <Col md={2}>
              <Badge
                bg={user.isAadharVerify ? "success" : "danger"}
                className="w-100 py-2"
              >
                Aadhaar Verification
              </Badge>
            </Col>

            <Col md={2}>
              <Badge
                bg={user.isFaceVerify ? "success" : "danger"}
                className="w-100 py-2"
              >
                Face Verification
              </Badge>
            </Col>

            <Col md={2}>
              <Badge
                bg={user.isVerifyMail ? "success" : "danger"}
                className="w-100 py-2"
              >
                Email Verification
              </Badge>
            </Col>
            <Col md={3}>
              <Badge
                bg={user.isVerifyPhoneNumber ? "success" : "danger"}
                className="w-90 py-2"
              >
                Phone Number Verification
              </Badge>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <div>

      </div>
      <Card className="shadow-sm border-0 rounded-4 mb-4">
        <Card.Body>
          <h5 style={{ color: "#E5484D" }} className="fw-bold mb-4">Education & Career</h5>

          <Row>
            <Col md={6}>


              <InfoRow label="Education" value={user.basicInfo?.education} />
              <InfoRow label="Institution" value={user.basicInfo?.institution} />

            </Col>

            <Col md={6}>
              <InfoRow label="Occupation" value={user?.basicInfo?.occupation} />
              <InfoRow label="Organization" value={user.basicInfo?.organization || "-"} />


            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="shadow-sm border-0 rounded-4 mb-4">
        <Card.Body className="p-4">
          <h5 style={{ color: "#E5484D" }} className="fw-bold mb-3 text-uppercase tracking-wide fs-6">
            Location Information
          </h5>
          <InfoRow label="Current City" value={user.basicInfo?.currentCity} />
        </Card.Body>
      </Card>


      {user?.aadhar && (
        <Card className="shadow-sm border-0 rounded-4 mb-4">
          <Card.Body className="p-4">
            <h5 style={{ color: "#E5484D" }} className="fw-bold mb-4 text-uppercase tracking-wide fs-6">
              Aadhaar Details
            </h5>
            <Row className="g-4">
              <Col md={4} className="text-center">
                <div className="bg-white p-2 rounded-3 border h-100 d-flex align-items-center justify-content-center">
                  <Image
                    src={user?.aadhar?.url}
                    fluid
                    rounded
                    className="shadow-xs object-fit-contain"
                    style={{ maxHeight: "220px" }}
                  />
                </div>
              </Col>
              <Col md={8}>
                <Row>
                  <Col md={6}>
                    <InfoRow label="Full Name" value={user?.aadhar?.aadhaar_xml_data?.full_name} />
                    <InfoRow label="DOB" value={user?.aadhar?.aadhaar_xml_data?.dob} />
                    <InfoRow label="Gender" value={user?.aadhar?.aadhaar_xml_data?.gender} />
                    <InfoRow label="Aadhaar No" value={user?.aadhar?.aadhaar_xml_data?.masked_aadhaar} />
                  </Col>
                  <Col md={6}>
                    <InfoRow
                      label="Guardian"
                      value={user?.aadhar?.aadhaar_xml_data?.father_name || user?.aadhar?.aadhaar_xml_data?.care_of}
                    />
                    <InfoRow label="Pincode" value={user?.aadhar?.aadhaar_xml_data?.zip} />
                    <InfoRow label="District" value={user?.aadhar?.aadhaar_xml_data?.address?.dist} />
                    <InfoRow label="State" value={user?.aadhar?.aadhaar_xml_data?.address?.state} />
                  </Col>
                </Row>
                <div className="mt-3">
                  <span className="d-block text-black fw-bold text-uppercase tracking-wider mb-2">Registered Address</span>
                  <div className="p-3 rounded-3 bg-white border text-secondary small fw-medium">
                    {user?.aadhar?.aadhaar_xml_data?.full_address || "-"}
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}




      {/* PREFERENCES */}
      <Card className="shadow-sm border-0 rounded-4">
        <Card.Body>
          <h5 style={{ color: "#E5484D" }} className="fw-bold  mb-4">User Preferences</h5>

          <Row>
            {[
              ...new Map(
                user.userPreference?.map((item) => [
                  item.question,
                  item,
                ])
              ).values(),
            ].map((pref) => {
              const currentQuestion = questions[pref.question];
              return (
                <Col md={4} lg={3} key={pref._id} className="mb-3">
                  <div style={{ backgroundColor: "#E5484D" }} className="border rounded-3 p-3 h-100">
                    <small className=" fw-bold text-white d-block text-capitalize">
                      {currentQuestion?.title || pref.question}
                    </small>

                    <div className=" text-white mt-1">
                      {currentQuestion?.options?.[pref.answer] || pref.answer}
                    </div>
                  </div>
                </Col>
              )
            })}
          </Row>
        </Card.Body>
      </Card>

      {lifecycle.length > 0 && <Card className="shadow-sm border-0 rounded-4">
        <Card.Body>
          <h5 style={{ color: "#E5484D" }} className="fw-bold  mb-4">Life Style Matched Profiles</h5>

          <Row>
            {lifecycle.map((pref) => (
              <Col md={4} lg={3} key={pref._id} className="mb-3">
                <div
                  style={{ backgroundColor: "#E5484D" }}
                  className="border rounded-3 p-3 h-100 text-center"
                >
                  {/* Image Placeholder */}
                  <div className="mb-3">
                    <img
                      src={pref.image ? pref.image : "https://img.magnific.com/free-vector/woman-with-long-brown-hair-pink-shirt_90220-2940.jpg?semt=ais_hybrid&w=740&q=80"}
                      alt="User"
                      className="rounded-circle border"
                      width={80}
                      height={80}
                    />
                  </div>

                  <small onClick={() => navigate(`/user-detail/${pref?._id}`)} className="fw-bold cursor-pointer text-white d-block text-capitalize">
                    {pref?.name}
                  </small>

                  <div className="text-white mt-1 fs-5 fw-semibold">
                    {pref?.matchPercentage}%
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>}

    </Container>
  );
};

export default UserDetailPage;





